// English: every area of the app, one file per area in ./<area>/en.js.
// Areas keep helpers and reviewers apart; keys are unique across areas (i18n.test.js).
import core from './core/en.js';
import common from './common/en.js';
import html from './html/en.js';
import account from './account/en.js';
import vault from './vault/en.js';
import share from './share/en.js';
import views from './views/en.js';
import routines from './routines/en.js';
import mobile from './mobile/en.js';
import app from './app/en.js';
import sync from './sync/en.js';
import history from './history/en.js';

export default { ...core, ...common, ...html, ...account, ...vault, ...share, ...views, ...routines, ...mobile, ...app, ...sync, ...history };
